import { DATA_LAYER_EVENT_START_TRIAL } from '_constants/dataLayer';
import { FB_PIXEL_EVENT_TRIAL_START } from '_constants/facebookPixel';
import { DEFAULT_PRICE_CURRENCY } from '_constants/subscriptionConstants';
import store from '_services/Redux/store';
import DataLayer from 'Components/DataLayer';
import {
    CHECKOUT_META_TRIAL_START_PARAM,
    consumeCheckoutMetaEventId,
    consumeCheckoutMetaPixelPayload,
    consumeCheckoutUserEmail,
    hasStoredCheckoutMetaPixelPayload,
} from 'Hooks/useStripeCheckout';
import FacebookPixel, { FbPixelTrialStartDataShape } from '.';

const DEFAULT_TRIAL_START_PAYLOAD: FbPixelTrialStartDataShape = {
    currency: DEFAULT_PRICE_CURRENCY,
    value: 0,
    content_type: 'subscription',
    content_name: 'Membership Year',
    content_category: 'year',
    subscription_interval: 'year',
};

export const shouldTrackTrialStartFromCheckoutSuccess = (
    search?: string | null,
): boolean => {
    const currentSearch =
        search ??
        (typeof window === 'undefined' ? null : window.location.search);

    if (!currentSearch) {
        return false;
    }

    const params = new URLSearchParams(currentSearch);

    return (
        params.get('checkoutSuccess') === 'true' &&
        (params.get(CHECKOUT_META_TRIAL_START_PARAM) === 'true' ||
            hasStoredCheckoutMetaPixelPayload())
    );
};

const trackTrialStartFromCheckoutSuccess = (): boolean => {
    if (!shouldTrackTrialStartFromCheckoutSuccess()) {
        return false;
    }

    const metaEventId = consumeCheckoutMetaEventId();
    const data =
        consumeCheckoutMetaPixelPayload() ?? DEFAULT_TRIAL_START_PAYLOAD;

    FacebookPixel.track(
        FB_PIXEL_EVENT_TRIAL_START,
        data,
        metaEventId ? { eventID: metaEventId } : undefined,
    );

    const email =
        consumeCheckoutUserEmail() ?? store.getState().user.data?.email;

    DataLayer.push({
        event: DATA_LAYER_EVENT_START_TRIAL,
        user_email: email,
    });

    return true;
};

export default trackTrialStartFromCheckoutSuccess;
